export interface CaptureResult {
  image: string;
  mibiData: string;
}

export enum MiSnapErrorCode {
  ANALYSIS = 'ERR_ANALYSIS',
  CAMERA_DENIED = 'ERR_CAMERA_DENIED',
  CANCELLED = 'ERR_CANCELLED',
  CAPTURE = 'ERR_CAPTURE',
  EXCEPTION = 'ERR_EXCEPTION',
  INVALID_SIDE = 'ERR_INVALID_SIDE',
  LICENSE_INVALID = 'ERR_LICENSE_INVALID',
  NO_LICENSE = 'ERR_NO_LICENSE',
  NO_VC = 'ERR_NO_VC',
  SETTINGS = 'ERR_SETTINGS',
}
